"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var SidebarMenuItem = function SidebarMenuItem(_ref) {
  var item = _ref.item,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      link = _ref.link;

  if (link) {
    return (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(link),
      className: (0, _classnames.default)('control-side-menu__menu-item', "control-side-menu__menu-item-".concat(item.iconName), {
        active: isActive
      })
    }, (0, _preact.h)(_assets.default, {
      icon: item.iconName,
      width: 20,
      height: 20,
      color: isActive ? ' #FFFFFF' : '#D5D6D6'
    }), (0, _preact.h)("div", {
      className: "control-side-menu__menu-item-label"
    }, (0, _preact.h)("span", null, item.label)));
  }

  return (0, _preact.h)("div", {
    onClick: onClick,
    className: (0, _classnames.default)('control-side-menu__menu-item', "control-side-menu__menu-item-".concat(item.iconName), {
      active: isActive
    })
  }, (0, _preact.h)(_assets.default, {
    icon: item.iconName,
    width: 20,
    height: 20,
    color: isActive ? ' #FFFFFF' : '#D5D6D6'
  }), (0, _preact.h)("div", {
    className: "control-side-menu__menu-item-label"
  }, (0, _preact.h)("span", null, item.label)));
};

var _default = SidebarMenuItem;
exports.default = _default;